module.exports = __webpack_public_path__ + "static/media/maxx.6bb0b05d.svg";